import { useSearchTableFromRoute } from '@aibees/elephant/hooks';
import { Alert } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import { TemplateProvider } from '../export-dialog/context/TemplateContext';
import * as Styled from './styles';
import * as SX from './sx';
import type { SearchTableActionDialogNotesProps as Props } from './types';

export const SearchTableActionDialogNotes = memo(
  ({ className, config }: Props) => {
    const table = useSearchTableFromRoute();
    const items = config?.[table!];

    return (
      <TemplateProvider>
        <Styled.Wrapper
          className={classnames('SearchTableActionDialogNotes', className)}
          sx={SX.root}
        >
          {items?.map((item, i) => (
            <Alert
              key={i.toString()}
              severity="default"
              variant="outlined"
              message={item.title}
            />
          ))}
        </Styled.Wrapper>
      </TemplateProvider>
    );
  }
);

SearchTableActionDialogNotes.displayName = 'SearchTableActionDialogNotes';
